import { AutogenModelProspectActivity, AutogenRowProspectActivity } from "./autogen/AutogenModelProspectActivity";

export class ModelProspectActivity extends AutogenModelProspectActivity<RowProspectActivity> {
	constructor() {
		super(RowProspectActivity);
	}
}

export class RowProspectActivity extends AutogenRowProspectActivity {
}